import {PlantId} from '@hconnect/common/hproduce/types'
import {Box, FormControl, InputLabel, MenuItem, Select, alpha} from '@mui/material'
import React from 'react'

import {useUikitTranslation} from '../../common'

export type Plant = {
  plantId: PlantId
  plantName: string
}

type PlantSelectProps = {
  activePlantId: PlantId
  'data-test-id': string
  plants: Plant[]
  onChange: (next: PlantId) => void
}

export const PlantSelect: React.FC<PlantSelectProps> = ({
  activePlantId,
  'data-test-id': dataTestId,
  plants,
  onChange
}) => {
  const {t} = useUikitTranslation()

  return (
    <Box p={2} data-test-id={dataTestId}>
      <FormControl
        variant="standard"
        sx={({palette, breakpoints}) => ({
          width: '100%',
          p: 1,
          background: alpha(palette.background.default, 0.03),
          border: `1.5px solid ${alpha(palette.common.white, 0.4)}`,
          boxShadow: 'inset 0px 4px 4px rgba(31, 73, 94, 0.08)',
          borderRadius: '4px',
          '& .MuiInput-underline, & .MuiInput-underline:hover': {
            '&::after,&::before': {
              borderBottom: 'none'
            }
          },
          [breakpoints.down('md')]: {
            py: 0
          }
        })}
      >
        <InputLabel
          sx={({palette, spacing}) => ({
            color: palette.text.secondary,
            top: '5px',
            left: spacing(1),
            '&.MuiFormLabel-root.MuiFormLabel-focused': {
              color: '#5E7A8C'
            }
          })}
        >
          {t('plantSelection.selectPlant', 'Select plant')}
        </InputLabel>
        <Select
          sx={{
            '&.MuiOutlinedInput-root': {
              padding: 0,
              fontWeight: 500
            }
          }}
          onChange={(event) => {
            onChange(event.target.value)
          }}
          value={activePlantId}
          disableUnderline
        >
          {plants?.map((detail) => (
            <MenuItem key={detail.plantId} value={detail.plantId}>
              {detail.plantName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
